import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Radio, Input } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import ProdutoFrame from './ProdutoFrame';
import ServicoFrame from './ServicoFrame';
import ItemFotoProduto from './ItemFotoProduto';

const { Item: ItemForm } = Form;

export default class VendaItemForm extends Component {
  state = {
    editando: false,

    listaProdutos: [],
    tipoTela: '',

    registro: {
      mi_seq: 0,
      mi_item: { key: '0' },
      mi_servico: { key: '0' },
      mi_item_Avulso: '',
      prod_codigo: '',
      prod_descricao: '',
      prod_ncm: '',
      prod_cod_barras: '',
      prod_imagem: '',
      prod_empresa: '',
      med_descricao: '',
      mi_qtde: 1,
      mi_vlr_unit: 0,
      mi_vlr_venda: 0,
      mi_vlr_venda_min: 0,
      mi_perc_desc: 0,
      mi_vlr_desc: 0,
      mi_vlr_acres: 0,
      mi_vlr_total: 0,
      mi_calc_estoque: 1,
      osia_custo_unit: 0,
      tipoItem: 'P',
    }

  };


  carregarProdutoSelecionado = () => {
    const selecionado = this.props.produtoSelecionado;
    if (!selecionado || !selecionado.registro) return;
    const registro = { ...selecionado.registro };
    this.setState({
      registro,
      mi_item: registro.mi_item,
      listaProdutos: selecionado.listaProdutos || [],
      tipoTela: selecionado.tipoTela,
      editando: Boolean(selecionado.editando),
    });
  };

  componentDidUpdate(propsAnterior) {
    if (this.props.produtoSelecionado !== propsAnterior.produtoSelecionado ||
        (this.props.visivel && !propsAnterior.visivel)) {
      this.carregarProdutoSelecionado();
    }
  }

  componentDidMount() {
    this.carregarProdutoSelecionado();
  }

  renderProduto = () => {
    const { editando, registro } = this.state;
    const produto = registro.mi_item || {};
    if (editando) {
      const descricao = produto.label || registro.prod_descricao || produto.descr || '';
      return (
        <Form.Item label="Produto">
          <Input value={descricao} title={typeof descricao === 'string' ? descricao : undefined}
            readOnly aria-label="Produto da venda" style={{ width: '100%' }} />
        </Form.Item>
      );
    }
    return (
      <ProdutoFrame label="Produto" id="mi_item" value={registro.mi_item}
        width="100%" onChange={this.onChangeProduto} disabled={false} />
    );
  };

  onOK = () => {
    const { mi_seq, mi_item, mi_servico, mi_item_Avulso, mi_qtde, mi_vlr_unit, mi_vlr_venda, mi_vlr_venda_min,
      mi_perc_desc, mi_vlr_acres, mi_vlr_desc, mi_vlr_total, mi_calc_estoque, osia_custo_unit, tipoItem } = this.state.registro;

    let iIndProd = -1;
    if (tipoItem === 'P') {
      if ((!mi_item) || (mi_item.key === '0') || (mi_item.key === '')) {
        Modal.warning({ title: 'Aviso!', content: 'Informe o Produto', });
        return;
      }
      const vlrTotalAux = parseFloat(mi_vlr_total);
      if (!vlrTotalAux) {
        Modal.warning({ title: 'Aviso!', content: 'Informe o Valor' });
        return;
      }
    } else if (tipoItem === 'S') {
      if ((!mi_servico) || (mi_servico.key === '0') || (mi_servico.key === '')) {
        Modal.warning({ title: 'Aviso!', content: 'Informe o Serviço', });
        return;
      }
    } else if (tipoItem === 'A') {
      if ((!mi_item_Avulso) || (mi_item_Avulso === '')) {
        Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição do Item Avulso' });
        return;
      }
    }


    if (!mi_qtde) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Quantidade' });
      return;
    }




    let iIndItem = -1;
    if (mi_seq >= 0) {
      for (var x in this.state.listaProdutos) {
        if (String(this.state.listaProdutos[x].mi_seq) === String(mi_seq)) {
          iIndItem = x;
        }
      }
    }


    if (parseInt(iIndItem) >= 0) {

      this.state.listaProdutos[iIndItem].mi_qtde = parseFloat(mi_qtde);
      this.state.listaProdutos[iIndItem].osia_custo_unit = parseFloat(osia_custo_unit);
      this.state.listaProdutos[iIndItem].mi_vlr_unit = parseFloat(mi_vlr_unit);
      this.state.listaProdutos[iIndItem].mi_perc_desc = parseFloat(mi_perc_desc === '' ? '0' : mi_perc_desc);
      this.state.listaProdutos[iIndItem].mi_vlr_desc = parseFloat(mi_vlr_desc === '' ? '0' : mi_vlr_desc);
      this.state.listaProdutos[iIndItem].mi_vlr_acres = parseFloat(mi_vlr_acres === '' ? '0' : mi_vlr_acres);
      this.state.listaProdutos[iIndItem].mi_vlr_total = parseFloat(mi_vlr_total);

      if (tipoItem === 'A') {
        this.state.listaProdutos[iIndItem].mi_item_Avulso = mi_item_Avulso;
      }

    } else {

      if (tipoItem === 'P') {

        this.state.listaProdutos.push({
          ven_idf: 0,
          venc_idf: 0,
          mi_idf_condicional: 0,
          mi_item: this.state.mi_item.pest_item,
          mi_servico: { key: '0' },
          mi_item_Avulso: '',
          mi_seq: this.state.listaProdutos.length + 1,
          prod_idf: this.state.mi_item.pest_item,
          pest_qtde: this.state.mi_item.pest_qtde,
          prod_grade: this.state.mi_item.prod_grade,
          mi_item_tamanho: this.state.mi_item.pest_tamanho,
          mi_item_cor: this.state.mi_item.pest_cor,
          ptam_descricao: this.state.mi_item.ptam_descricao,
          pcor_descricao: this.state.mi_item.pcor_descricao,
          prod_codigo: this.state.mi_item.cod,
          prod_descricao: this.state.mi_item.descr,
          prod_ncm: this.state.mi_item.prod_ncm,
          prod_cod_barras: this.state.mi_item.prod_cod_barras,
          prod_imagem: this.state.mi_item.prod_imagem || this.state.registro.prod_imagem || '',
          prod_empresa: this.state.mi_item.prod_empresa || this.state.registro.prod_empresa || '',
          med_descricao: this.state.mi_item.med_descricao,
          mi_qtde: parseFloat(mi_qtde),
          osia_custo_unit: 0,
          mi_vlr_unit: parseFloat(mi_vlr_unit),
          mi_vlr_venda: mi_vlr_venda,
          mi_vlr_venda_min: mi_vlr_venda_min,
          mi_perc_desc: parseFloat(mi_perc_desc === '' ? '0' : mi_perc_desc),
          mi_vlr_desc: parseFloat(mi_vlr_desc === '' ? '0' : mi_vlr_desc),
          mi_vlr_acres: parseFloat(mi_vlr_acres === '' ? '0' : mi_vlr_acres),
          mi_vlr_total: parseFloat(mi_vlr_total),
          mi_calc_estoque: mi_calc_estoque,
          tipoItem,
        });

      } else if (tipoItem === 'S') {

        this.state.listaProdutos.push({
          ven_idf: 0,
          venc_idf: 0,
          mi_idf_condicional: 0,
          mi_item: { key: '0' },
          mi_servico: mi_servico.key,
          mi_item_Avulso: '',
          mi_seq: this.state.listaProdutos.length + 1,
          prod_idf: '',
          pest_qtde: 0,
          prod_grade: '',
          mi_item_tamanho: '',
          mi_item_cor: '',
          ptam_descricao: '',
          pcor_descricao: '',
          prod_codigo: '',
          prod_descricao: mi_servico.label,
          prod_ncm: '',
          prod_cod_barras: '',
          med_descricao: '',
          mi_qtde: parseFloat(mi_qtde),
          osia_custo_unit: 0,
          mi_vlr_unit: parseFloat(mi_vlr_unit),
          mi_vlr_venda: mi_vlr_venda,
          mi_vlr_venda_min: mi_vlr_venda_min,
          mi_perc_desc: parseFloat(mi_perc_desc === '' ? '0' : mi_perc_desc),
          mi_vlr_desc: parseFloat(mi_vlr_desc === '' ? '0' : mi_vlr_desc),
          mi_vlr_acres: parseFloat(mi_vlr_acres === '' ? '0' : mi_vlr_acres),
          mi_vlr_total: parseFloat(mi_vlr_total),
          mi_calc_estoque: 0,
          tipoItem,
        });

      } else if (tipoItem === 'A') {

        this.state.listaProdutos.push({
          ven_idf: 0,
          venc_idf: 0,
          mi_idf_condicional: 0,
          mi_item: { key: '0' },
          mi_servico: 0,
          mi_item_Avulso: mi_item_Avulso,
          mi_seq: this.state.listaProdutos.length + 1,
          prod_idf: '',
          pest_qtde: 0,
          prod_grade: '',
          mi_item_tamanho: '',
          mi_item_cor: '',
          ptam_descricao: '',
          pcor_descricao: '',
          prod_codigo: '',
          prod_descricao: mi_item_Avulso,
          prod_ncm: '',
          prod_cod_barras: '',
          med_descricao: '',
          mi_qtde: parseFloat(mi_qtde),
          osia_custo_unit: parseFloat(osia_custo_unit),
          mi_vlr_unit: parseFloat(mi_vlr_unit),
          mi_vlr_venda: mi_vlr_venda,
          mi_vlr_venda_min: mi_vlr_venda_min,
          mi_perc_desc: parseFloat(mi_perc_desc === '' ? '0' : mi_perc_desc),
          mi_vlr_desc: parseFloat(mi_vlr_desc === '' ? '0' : mi_vlr_desc),
          mi_vlr_acres: parseFloat(mi_vlr_acres === '' ? '0' : mi_vlr_acres),
          mi_vlr_total: parseFloat(mi_vlr_total),
          mi_calc_estoque: 0,
          tipoItem,
        });

      }

    }

    this.props.onSalvarProdutoClick(this.state.listaProdutos);
  };




  onChangeProduto = event => {
    // console.log('onChangeProduto: ', event);
    const { registro } = this.state;
    const vlrUnit = this.state.tipoTela === 'COM' ? parseFloat(event.mi_item.prod_vlr_custo) : parseFloat(event.mi_item.vlrVenda)

    registro['mi_item'] = event.mi_item;
    registro['prod_imagem'] = event.mi_item && event.mi_item.prod_imagem ? event.mi_item.prod_imagem : '';
    registro['prod_empresa'] = event.mi_item && event.mi_item.prod_empresa ? event.mi_item.prod_empresa : '';
    registro['mi_vlr_unit'] = vlrUnit;
    this.setState({ ...event, registro });

    this.calculoItem(registro.mi_qtde, vlrUnit, registro.mi_perc_desc, registro.mi_vlr_desc);
  }

  onInputChangeQtde = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
    this.calculoItem(value, registro.mi_vlr_unit, registro.mi_perc_desc, registro.mi_vlr_desc);
  }

  onInputChangeVlrUnit = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
    this.calculoItem(registro.mi_qtde, value, registro.mi_perc_desc, registro.mi_vlr_desc);
  }

  onInputChangeVlrCusto = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  }

  onInputChangePercDesc = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
    this.calculoItem(registro.mi_qtde, registro.mi_vlr_unit, value, 0);
  }

  onInputChangeVlrDesc = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
    this.calculoItem(registro.mi_qtde, registro.mi_vlr_unit, 0, value);
  }

  calculoItem = (mi_qtde, mi_vlr_unit, mi_perc_desc, mi_vlr_desc) => {
    const { registro } = this.state;
    const vlrUnit = parseFloat(mi_vlr_unit);
    const qtde = parseFloat(mi_qtde);

    // let percDesc = mi_perc_desc ? (parseFloat(mi_perc_desc) / 100) : 0;
    // let vlrDesc = 0;
    // vlrDesc = parseFloat((parseFloat(mi_qtde) * parseFloat(vlrUnit)) * percDesc);
    // let vlrTotal = parseFloat(parseFloat(vlrUnit) * parseFloat(qtde)) - parseFloat(vlrDesc);

    let percDesc = parseFloat(mi_perc_desc);
    let vlrDesc = parseFloat(mi_vlr_desc);

    if (vlrDesc === 0) {
      percDesc = mi_perc_desc ? (parseFloat(mi_perc_desc) / 100) : 0;
      vlrDesc = parseFloat((parseFloat(mi_qtde) * parseFloat(vlrUnit)) * percDesc);
    }

    let vlrTotal = parseFloat(parseFloat(vlrUnit) * parseFloat(qtde)) - parseFloat(vlrDesc);

    registro.mi_vlr_total = vlrTotal;
    registro.mi_vlr_desc = vlrDesc;
    this.setState({
      registro
    });
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };

  onChangeTipoItem = event => {
    // console.log('radio checked', event.target);
    const { registro } = this.state;
    registro['tipoItem'] = event.target.value;
    this.setState({ registro });
  };

  onChangeServico = event => {
    const { registro } = this.state;
    registro['mi_servico'] = {
      key: event.mi_servico.key,
      label: event.mi_servico.label,
      serv_valor: event.mi_servico.serv_valor,
    }
    registro['mi_vlr_unit'] = event.mi_servico.serv_valor;
    this.setState(event);

    this.calculoItem(registro.mi_qtde, parseFloat(event.mi_servico.serv_valor), registro.mi_perc_desc, registro.mi_vlr_desc);
  }




  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------


  render() {
    const { onFecharModalProdutoClick, visivel } = this.props;

    const { editando, tipoTela } = this.state;
    const { mi_item, mi_servico, mi_item_Avulso, mi_qtde, mi_vlr_unit, mi_perc_desc, mi_vlr_desc, mi_vlr_total, tipoItem, osia_custo_unit } = this.state.registro;

    // console.log('VendaItemForm.this.state: ', this.state);

    return (
      <Modal
        title={editando ? "Editar Produto" : "Incluir Produto"}
        visible={visivel}
        destroyOnClose
        onCancel={onFecharModalProdutoClick}
        footer={null}
        width={"50%"}
        style={{ top: 50 }}
      >
        <div>

          {tipoTela === 'OS' || tipoTela === 'ORC' ? (
            <Row>
              <Radio.Group onChange={this.onChangeTipoItem} value={tipoItem} disabled={editando}>
                <Radio value={'P'}>Produto</Radio>
                <Radio value={'S'}>Serviço</Radio>
                <Radio value={'A'}>Avulso</Radio>
              </Radio.Group>
            </Row>
          ) : null}

          <Row>
            {tipoTela === 'OS' || tipoTela === 'ORC' ? (
              <div>
                {tipoItem === 'P' ? (
                  <Col xs={24} style={{ marginTop: 10 }}>
                    {this.renderProduto()}
                  </Col>
                ) : null}
                {tipoItem === 'S' ? (
                  <Col xs={24} style={{ marginTop: 10 }}>
                    <span>Serviço</span>
                    <ServicoFrame
                      label=""
                      id="mi_servico"
                      value={mi_servico}
                      width={"100%"}
                      onChange={this.onChangeServico}
                      descricaoPrimeiroItem="Selecione um Serviço"
                      disabled={editando}
                    />
                  </Col>
                ) : null}
                {tipoItem === 'A' ? (
                  <Col xs={24} style={{ marginTop: 10 }}>
                    <span>Descrição do Item Avulso</span>
                    <InputForm
                      id="mi_item_Avulso"
                      ref="mi_item_Avulso"
                      value={mi_item_Avulso}
                      placeholder="Informe a Descrição do Item Avulso"
                      maxLength={50}
                      onChange={this.onChange}
                      validator={value => Boolean(value)}
                    />
                  </Col>
                ) : null}
              </div>
            ) : (
              <Col xs={24}>
                {this.renderProduto()}
              </Col>
            )}



            {tipoItem === 'P' ? (
              <ItemFotoProduto
                produtoId={mi_item}
                prodImagem={this.state.registro.prod_imagem || (mi_item && mi_item.prod_imagem)}
                prodEmpresa={this.state.registro.prod_empresa || (mi_item && mi_item.prod_empresa)}
                tamanho={110}
                alt={this.state.registro.prod_descricao || (mi_item && (mi_item.descr || mi_item.label))}
                containerStyle={{ textAlign: 'center', marginTop: 10, marginBottom: 28 }}
              />
            ) : null}

            <Col xs={24} sm={5} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Qtde</span>
              <InputForm
                type="number"
                id="mi_qtde"
                ref="mi_qtde"
                value={mi_qtde}
                onChange={this.onInputChangeQtde}
              />
            </Col>
            {tipoTela === 'OS' && tipoItem === 'A' ? (
              <Col xs={24} sm={5} style={{ marginTop: -20, paddingRight: 20 }}>
                <span>Preço Custo</span>
                <InputForm
                  type="number"
                  id="osia_custo_unit"
                  ref="osia_custo_unit"
                  value={osia_custo_unit}
                  onChange={this.onInputChangeVlrCusto}
                />
              </Col>
            ) : null}
            <Col xs={24} sm={5} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>{this.props.tipoTela === 'COM' ? 'Preço Custo' : 'Valor Venda'}</span>
              <InputForm
                type="number"
                id="mi_vlr_unit"
                ref="mi_vlr_unit"
                value={mi_vlr_unit}
                onChange={this.onInputChangeVlrUnit}
              />
            </Col>
            {tipoTela === 'OS' && tipoItem === 'A' ? null : (
              <div>
                <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 20 }}>
                  <span>Desc (%)</span>
                  <InputForm
                    type="number"
                    id="mi_perc_desc"
                    ref="mi_perc_desc"
                    value={mi_perc_desc}
                    onChange={this.onInputChangePercDesc}
                  />
                </Col>
                <Col xs={24} sm={5} style={{ marginTop: -20, paddingRight: 20 }}>
                  <span>Valor Desconto</span>
                  <InputForm
                    type="number"
                    id="mi_vlr_desc"
                    ref="mi_vlr_desc"
                    value={mi_vlr_desc}
                    onChange={this.onInputChangeVlrDesc}
                  />
                </Col>
              </div>
            )}
            <Col xs={24} sm={5} style={{ marginTop: -20 }}>
              <span>Valor Total</span>
              <InputForm
                type="number"
                id="mi_vlr_total"
                ref="mi_vlr_total"
                value={mi_vlr_total}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
          </Row>


          <ItemForm>
            <div className="divider-form" />
            <Row>
              <Col xs={24}>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={this.onOK}
                  className="btn-salvar"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onFecharModalProdutoClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>


      </Modal >



    );
  }
}



// WEBPACK FOOTER //
// ./src/components/VendaItemForm.js